<template>
  <div>

      <iframe src="https://docs.google.com/document/d/e/2PACX-1vRlfSfEcwPNeuT71e_A9eSwXMm0SUYFnHeVtEmYXYQeNtREXh3Y0AsgfuzvUKxBElZws7j7g5JnsUqT/pub?embedded=true" width="100%" height="650px"></iframe>

  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>